(() => {
  const wraps = Array.from(document.querySelectorAll('[data-gallery-wrap]'));
  wraps.forEach((wrap) => {
    const gallery = wrap.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const count = wrap.querySelector('[data-gallery-count]');
    const dotsHost = wrap.querySelector('[data-gallery-dots]');
    const prev = wrap.querySelector('[data-gallery-prev]');
    const next = wrap.querySelector('[data-gallery-next]');
    let raf = 0;

    const visibleItems = () => Array.from(gallery.querySelectorAll('[data-product-media], .product-media--custom')).filter((item) => !item.hidden);
    const itemLeft = (item) => gallery.scrollLeft + item.getBoundingClientRect().left - gallery.getBoundingClientRect().left;

    function activeIndex(items) {
      if (!items.length) return 0;
      const center = gallery.getBoundingClientRect().left + gallery.clientWidth / 2;
      let best = 0;
      let bestDistance = Infinity;
      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) { bestDistance = distance; best = index; }
      });
      return best;
    }

    function scrollToIndex(index) {
      const items = visibleItems();
      if (!items.length) return;
      const safeIndex = Math.max(0, Math.min(index, items.length - 1));
      gallery.scrollTo({ left: itemLeft(items[safeIndex]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    function renderDots() {
      if (!dotsHost) return;
      const items = visibleItems();
      dotsHost.replaceChildren();
      items.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Mostrar foto ' + (index + 1));
        button.addEventListener('click', () => scrollToIndex(index));
        dotsHost.appendChild(button);
      });
      if (prev) prev.hidden = items.length < 2;
      if (next) next.hidden = items.length < 2;
      if (dotsHost) dotsHost.hidden = items.length < 2;
      updateControls();
    }

    function updateControls() {
      const items = visibleItems();
      if (!items.length) return;
      const index = activeIndex(items);
      if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      if (dotsHost) {
        Array.from(dotsHost.children).forEach((button, dotIndex) => {
          if (dotIndex === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }
    }

    if (prev) prev.addEventListener('click', () => scrollToIndex(activeIndex(visibleItems()) - 1));
    if (next) next.addEventListener('click', () => scrollToIndex(activeIndex(visibleItems()) + 1));
    gallery.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { raf = 0; updateControls(); });
    }, { passive: true });

    const observer = new MutationObserver(() => {
      renderDots();
      const items = visibleItems();
      if (items.length) {
        const selectedHero = items.find((item) => item.classList.contains('is-selected-color-hero')) || items[0];
        requestAnimationFrame(() => gallery.scrollTo({ left: itemLeft(selectedHero), behavior: 'auto' }));
      }
    });
    observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });

    const productForm = document.querySelector('.product-form');
    if (productForm) {
      productForm.querySelectorAll('.product-option input').forEach((input) => {
        input.addEventListener('change', () => {
          requestAnimationFrame(() => {
            renderDots();
            const items = visibleItems();
            const selectedHero = items.find((item) => item.classList.contains('is-selected-color-hero')) || items[0];
            if (selectedHero) gallery.scrollTo({ left: itemLeft(selectedHero), behavior: 'auto' });
          });
        });
      });
    }

    renderDots();
    const initialItems = visibleItems();
    const initialHero = initialItems.find((item) => item.classList.contains('is-selected-color-hero')) || initialItems[0];
    if (initialHero) gallery.scrollTo({ left: itemLeft(initialHero), behavior: 'auto' });
  });
})();